import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable, EMPTY } from 'rxjs';
import { share, switchMap, take } from 'rxjs/operators';
import { AlertModalService } from 'app/shared/alert-modal.service';
import { CargoApiService } from 'app/api/cargoApi.service';
import { ClienteApiService } from 'app/api/clienteApi.service';
import { ServicoApiService } from 'app/api/servicoApi.service';
import { UsuariosService } from 'app/api/usuarios.service';
import {
  Servico,
  PessoaJuridica,
  Cargo,
} from 'app/model/models';
import { SubSink } from 'subsink';

import { DataTableDirective } from 'angular-datatables';
import { LanguageDataTable } from 'app/shared/datatable/translate-datatable';

@Component({
  selector: 'app-cargos-modelos-atualizar',
  templateUrl: './cargos-modelos-atualizar.component.html',
  styleUrls: ['./cargos-modelos-atualizar.component.css']
})
export class CargosModelosAtualizarComponent implements OnInit, OnDestroy {

  cargoDetalhe: Cargo;
  servico$: Observable<Servico[]>;
  servicos: Servico[];
  clientes$: Observable<PessoaJuridica[]>;
  clientes: PessoaJuridica[];
  addFormBasico: FormGroup;
  dadosBasicosRef;

  usuarioLogado: number;
  usuarioNome: string;
  idCliente: number;
  nomeCliente: string;
  idCargo: number;
  idServico: number;
  submitted = false;
  atualizando = false;
  carregando = false;
  order = 'nomeArquivoOrigem';
  reverse = true;

  @ViewChild(DataTableDirective, {static: false})
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  orderCondition: number = 3;
 
  initUnidades: number;

  @ViewChild('linkBasicsData') linkBasicsData: ElementRef;
  @ViewChild('basicsData') basicsData: ElementRef;
  @ViewChild('linkProfile') linkProfile: ElementRef;
  @ViewChild('profile') profile: ElementRef;

  saveUpdate: boolean = false;

  private subs = new SubSink();

  constructor(
    private cargosService: CargoApiService,
    private clientesService: ClienteApiService,
    private servicosService: ServicoApiService,
    private usuariosService: UsuariosService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertModalService
  ) {

    this.subs.sink = this.route.data.subscribe(
        (dados) => {
          this.cargoDetalhe = dados.cargosResolver;
          this.idCargo = this.cargoDetalhe.id;
          this.idCliente = this.cargoDetalhe.pessoaJuridicaId;
          this.idServico = this.cargoDetalhe.servicoId;
          this.initUnidades = this.cargoDetalhe.addUnidades;
    });

    this.addFormBasico = this.formBuilder.group({
        titulo: ['', Validators.required],
        descricao: [''],
        area: [''],
        nivel: [''],
        pessoaJuridicaId: [''],
        servicoId: [null],
        qtdeUnidades: [0],
        addUnidades: [0],
        urlLink: [''],
        tipoCargo: ['Modelo'],
      });

  }

  ngOnInit() {
    this.subs.sink = this.usuariosService.v1UsuariosLogadoGet()
    .subscribe(usuario => {
      this.usuarioNome = usuario.userName;
      this.usuarioLogado = usuario.pessoaJuridicaId;
    });
    this.getClientes();
    if (this.idCliente) {
      this.getServicoByCliente(this.idCliente);
    }

    this.addFormBasico.setValue({
      titulo: this.cargoDetalhe.titulo,
      descricao: this.cargoDetalhe.descricao,
      area: this.cargoDetalhe.area,
      nivel: this.cargoDetalhe.nivel,
      pessoaJuridicaId: this.cargoDetalhe.pessoaJuridicaId,
      servicoId: this.cargoDetalhe.servicoId || null,
      qtdeUnidades: this.cargoDetalhe.qtdeUnidades || 0,
      addUnidades: this.cargoDetalhe.addUnidades || 0,
      urlLink: this.cargoDetalhe.urlLink || null,
      tipoCargo: "Modelo",
    });

    this.dadosBasicosRef = {
      titulo: this.cargoDetalhe.titulo,
      descricao: this.cargoDetalhe.descricao,
      area: this.cargoDetalhe.area,
      nivel: this.cargoDetalhe.nivel,
      pessoaJuridicaId: this.cargoDetalhe.pessoaJuridicaId,
      servicoId: this.cargoDetalhe.servicoId,
      qtdeUnidades: this.cargoDetalhe.qtdeUnidades,
      addUnidades: this.cargoDetalhe.addUnidades,
      urlLink: this.cargoDetalhe.urlLink,
      tipoCargo: "Modelo",
    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      responsive: true,
      order: [],
      language: LanguageDataTable.portugues_datatables
    };


  }

  saveFull() {
    this.saveUpdate = true;
    this.saveCargo();
  }

  get f() { return this.addFormBasico.controls; }


  getClientes() {
    this.clientes$ = this.clientesService.v1ClienteGet().pipe(share());
    this.subs.sink = this.clientes$.subscribe(clientes => {
      this.clientes = clientes;
      clientes.forEach(cliente => {
      if (cliente.id === this.cargoDetalhe.pessoaJuridicaId) {
        this.nomeCliente = cliente.razaoSocial;
      }
      if (this.clientes.length === 1) {
          this.getServicoByCliente(cliente.id);
        }
      });
    });

  }

  selectServico(id: number) {
    this.idServico = id;
    if (this.idServico) {
      this.addFormBasico.patchValue({ servicoId: this.idServico });
    }
  }

  getServicoByCliente(id: number) {
    this.servico$ = this.servicosService.v1ServicoClienteClienteIdGet(id).pipe(share());
    this.subs.sink = this.servico$.subscribe(servicos => this.servicos = servicos)
  }

  saveCargo(): void {

    let formBasico = Object.keys(this.addFormBasico.value);
    let dadosDiferentes = formBasico.some((chave) => { // Verifica se houve alteração nos dados
      return this.addFormBasico.value[chave] !== this.dadosBasicosRef[chave];
    });

    if (dadosDiferentes) { 
      
      this.submitted = true;
      
      if (this.addFormBasico.invalid) { return; }

      this.subs.sink = this.cargosService.v1CargoCargoIdPut(this.idCargo, this.addFormBasico.value)
      .subscribe(success => {

        if (!this.saveUpdate) {
          this.alertService.showAlertSuccess('Dados Básicos atualizados com sucesso!');
        }

        this.idCargo = success.id;
        this.dadosBasicosRef = this.addFormBasico.value;

      }, error => {
        console.error("Erro:", error);
        if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
          this.alertService.showAlertDanger(error.Erros[0].Mensagem);
        } else {
          this.alertService.showAlertDanger('Erro ao atualizar Cargo Modelo. Por favor, tente mais tarde.');
        }
      });

      this.goTop(); 

    } else {

      if (!this.saveUpdate) {
        this.alertService.showAlertWarning('Nenhum campo foi editado, por isso, os dados básicos não foram alterados.');
      }

    }

  }

  onDelete(cargo: Cargo) {
    const result$ = this.alertService.showConfirm('Confirmação', 'Tem certeza que deseja excluir o Cargo Modelo?');
    result$.asObservable()
    .pipe(
      take(1),
      switchMap(result => result ? this.cargosService.v1CargoCargoIdDelete(cargo.id) : EMPTY)
    )
    .subscribe(
      success => {
        this.alertService.showAlertSuccess('Cargo Modelo excluído com sucesso!');
        this.router.navigate(['/cargos-modelo']);
      },
      error => {
        console.error("Erro:", error);
        if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
          this.alertService.showAlertDanger(error.Erros[0].Mensagem);
        } else {
          this.alertService.showAlertDanger('Erro ao excluir Cargo Modelo. Tente novamente mais tarde.');
        }
      }
    );
  }

  goTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  goBack(): void {
    this.router.navigateByUrl('/SkipPage', {skipLocationChange: true}).then(()=>
    this.router.navigate(['cargos-modelo/' + this.idCargo]));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
